import { render, staticRenderFns } from "./SelectTable.vue?vue&type=template&id=0bb25ae3&scoped=true"
import script from "./SelectTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./SelectTable.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./SelectTable.vue?vue&type=style&index=0&id=0bb25ae3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb25ae3",
  null
  
)

export default component.exports